module.exports = __webpack_public_path__ + "static/far-cry_banner-0f7c4060b91be1f510dd603b7c571862.jpg";